/* eslint-disable react/jsx-max-depth */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classnames from 'classnames';
import { capitalize, isEmpty, isNil, upperCase } from 'lodash';
import T from 'prop-types';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Dropdown, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import remarkGfm from 'remark-gfm';
import Icon from '../../components/icon/Icon';
import { CONFIRM_MODAL } from '../../components/modal/ConfirmModal';
import useGeocoder from '../../components/RightMenu/useGeocoder';
import Activity from '../../components/timeline/Activity';
import { ACTIVITY_TYPES } from '../../constants/activity';
import { deleteActivity, deleteAsset, showModal } from '../../redux/actions';
import text from '../../text';
import { isActivityFileDownload, isActivityType } from '../../utilities/activity';
import { formatDate, formatTime } from '../../utilities/date';
import { getShortenedAddressFromGeocoder } from '../../utilities/map';
import { isAdministrator, isStaff } from '../../utilities/user';
import ActivityAsset from './ActivityAsset';
import Invoice from './ActivityTemplates/Invoice';
import RequestForQuote from './ActivityTemplates/RFQ';
import JobStatusUpdate from './JobStatusUpdate';
import { FloatingPortal, useFloating, offset, flip, shift, autoUpdate, arrow } from '@floating-ui/react';
import { useClickOutside } from '../../hooks/useClickOutside';
import { IconButton } from '../../components/button';
import useEventListener from '../../hooks/useEventListener';
import { useSupersedeActivityMutation } from '../../redux/rtk';
import { SUPERSEDE_ACTIVITY } from '../../redux/constants/activity';
import { alertConstants } from '../../redux/constants';
var TypeIconMap = {
    file: 'clip',
    order: 'shopping-cart',
    note: 'speech',
    user: 'user-outline',
    alert: 'larki-icon',
    status: '?'
};
var ActivityTemplate = function(param) {
    var metadata = param.metadata, job = param.job, rfqCharges = param.rfqCharges;
    if (!job || !job.quote) {
        return null;
    }
    if (metadata && metadata.action === 'quote') {
        if (job.quote && job.quote.charges && rfqCharges) {
            return /*#__PURE__*/ React.createElement(RequestForQuote, {
                title: upperCase(text('requestForQuote')),
                job: job,
                rfqCharges: rfqCharges
            });
        } else {
            return /*#__PURE__*/ React.createElement(Invoice, {
                job: job
            });
        }
    } else {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
            className: "font-weight--600 mb-3 font-18"
        }, metadata && metadata.action === 'invoice' ? "".concat((metadata === null || metadata === void 0 ? void 0 : metadata.type) ? upperCase(metadata === null || metadata === void 0 ? void 0 : metadata.type) : '', " INVOICE CREATED") : upperCase(text('paymentReceived'))), /*#__PURE__*/ React.createElement(Link, {
            className: "font-weight-bold",
            style: {
                textDecoration: 'underline'
            },
            key: "viewPaymentReceipt",
            to: {
                pathname: metadata.receipt_url
            },
            target: "_blank"
        }, metadata && metadata.action === 'invoice' ? 'View Invoice' : text('viewPaymentReceipt')));
    }
};
ActivityTemplate.propTypes = {
    metadata: T.shape({
        action: T.string,
        receipt_url: T.string,
        type: T.string
    }),
    rfqCharges: T.array,
    job: T.object
};
// TODO: Refactor this to project activity
var JobActivity = function(props) {
    var _props_jobActivity = props.jobActivity, id = _props_jobActivity.id, created_at = _props_jobActivity.created_at, created_assets = _props_jobActivity.created_assets, title = _props_jobActivity.title, description = _props_jobActivity.description, type = _props_jobActivity.type, job_id = _props_jobActivity.job_id, project_id = _props_jobActivity.project_id, detailed_status_update = _props_jobActivity.detailed_status_update, is_notification_sent = _props_jobActivity.is_notification_sent, visibility = _props_jobActivity.visibility, created_user = _props_jobActivity.created_user, rfqCharges = _props_jobActivity.rfqCharges, metadata = _props_jobActivity.metadata, superseded_assets = _props_jobActivity.superseded_assets, currentProject = props.currentProject, currentUser = props.currentUser;
    var _useSupersedeActivityMutation = _sliced_to_array(useSupersedeActivityMutation(), 1), supersedeActivity = _useSupersedeActivityMutation[0];
    var dispatch = useDispatch();
    var geocode = useGeocoder().geocode;
    var _useState = _sliced_to_array(useState(null), 2), shortenedAddress = _useState[0], setShortenedAddress = _useState[1];
    var _useState1 = _sliced_to_array(useState('checking'), 2), addressStatus = _useState1[0], setAddressStatus = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isDropdownOpen = _useState2[0], setIsDropdownOpen = _useState2[1];
    var arrowRef = useRef(null);
    var _useFloating = useFloating({
        open: isDropdownOpen,
        onOpenChange: setIsDropdownOpen,
        middleware: [
            offset(6),
            flip(),
            shift(),
            arrow({
                element: arrowRef,
                padding: 5
            })
        ],
        whileElementsMounted: autoUpdate,
        placement: 'bottom-end'
    }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, middlewareData = _useFloating.middlewareData, placement = _useFloating.placement;
    // Check if the dropdown is flipped to the top
    var isFlipped = placement === null || placement === void 0 ? void 0 : placement.includes('top');
    var arrowStyles = middlewareData.arrow ? _object_spread({
        left: middlewareData.arrow.x != null ? "".concat(middlewareData.arrow.x, "px") : '',
        top: middlewareData.arrow.y != null ? "".concat(middlewareData.arrow.y, "px") : '',
        position: 'absolute',
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid rgba(0,0,0,0.15)'
    }, isFlipped ? {
        bottom: '-6px',
        transform: 'rotate(45deg)',
        borderWidth: '0 1px 1px 0'
    } : {
        top: '-6px',
        transform: 'rotate(45deg)',
        borderWidth: '1px 0 0 1px'
    }) : {};
    useClickOutside(refs.reference, function() {
        return setIsDropdownOpen(false);
    }, [
        '.ActivityDropdownMenu'
    ], false);
    // Close dropdown when scrolling
    useEventListener('scroll', function() {
        if (isDropdownOpen) {
            setIsDropdownOpen(false);
        }
    }, window, {
        capture: true
    });
    var onDeleteActivity = function() {
        dispatch(showModal(CONFIRM_MODAL, {
            onConfirm: function() {
                return dispatch(deleteActivity(project_id, id));
            },
            title: type === ACTIVITY_TYPES.note ? text('deleteNote') : text('deleteFileUploadActivity'),
            body: type === ACTIVITY_TYPES.note ? text('deleteNoteBody') : text('deleteFileUploadActivityBody'),
            okLabel: text('delete')
        }));
    };
    var onDeleteAsset = function(assetId) {
        dispatch(showModal(CONFIRM_MODAL, {
            onConfirm: function() {
                return dispatch(deleteAsset(project_id, job_id, id, assetId));
            },
            title: text('deleteFile'),
            body: text('deleteFileBody'),
            okLabel: text('delete')
        }));
    };
    var getActivityIcon = function() {
        // handle old File Downloaded activities w/c are still under assets
        if (isActivityFileDownload({
            title: title,
            description: description
        }) && type !== 'larki') {
            return TypeIconMap.alert;
        }
        return TypeIconMap[type] || 'speech';
    };
    var getActivityType = function(type) {
        // handle old File Downloaded activites that were saved as notes
        if ([
            ACTIVITY_TYPES.note,
            ACTIVITY_TYPES.alert
        ].includes(type) && isActivityFileDownload({
            title: title,
            description: description
        })) {
            return 'download';
        }
        return type;
    };
    var onSupersede = function() {
        dispatch(showModal(CONFIRM_MODAL, {
            onConfirm: /*#__PURE__*/ _async_to_generator(function() {
                var result, error, _error_response_data, _error_response;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                supersedeActivity({
                                    projectId: project_id,
                                    activityId: id,
                                    isSuperseded: isSuperseded
                                }).unwrap()
                            ];
                        case 1:
                            result = _state.sent();
                            // TODO: Remove this once most of API migrated to
                            // RTK query then we can use invalidateTags
                            dispatch({
                                type: SUPERSEDE_ACTIVITY,
                                payload: {
                                    projectId: project_id,
                                    activityId: id,
                                    supersededAssets: result
                                }
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            dispatch({
                                type: alertConstants.ALERT_ERROR,
                                payload: {
                                    message: (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message
                                }
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }),
            title: text('supersedeConfirmTitle', {
                action: isSuperseded ? 'reverse supersede' : 'supersede'
            }),
            body: text('supersedeConfirmBody', {
                action: isSuperseded ? 'Reversed superseded' : 'Superseded',
                include: isSuperseded ? 'be' : 'not be'
            }),
            okLabel: text('supersedeConfirmYes', {
                action: isSuperseded ? 'reverse supersede' : 'supersede'
            }),
            cancelLabel: text('supersedeConfirmNo'),
            isLinkButton: true,
            isButtonFullWidth: false,
            isFooterButtonReversed: true,
            isAttentionIconVisible: true,
            isCloseButtonVisible: true
        }));
    };
    useEffect(function() {
        var isMounted = true;
        var fetchGeocodedAddress = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _currentProject_jobs_find, fullAddress, place, shortenedAddress, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(job_id && !isEmpty(currentProject === null || currentProject === void 0 ? void 0 : currentProject.jobs) && addressStatus === 'checking')) return [
                                3,
                                4
                            ];
                            fullAddress = (_currentProject_jobs_find = currentProject.jobs.find(function(job) {
                                return job.id === job_id;
                            })) === null || _currentProject_jobs_find === void 0 ? void 0 : _currentProject_jobs_find.full_address;
                            if (!fullAddress) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                geocode(fullAddress)
                            ];
                        case 2:
                            place = _state.sent();
                            if (isMounted) {
                                shortenedAddress = getShortenedAddressFromGeocoder(place);
                                setShortenedAddress(shortenedAddress);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error('Geocode error:', error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (isMounted) {
                                setAddressStatus('done');
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchGeocodedAddress() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchGeocodedAddress();
        return function() {
            isMounted = false;
        };
    }, [
        job_id,
        currentProject === null || currentProject === void 0 ? void 0 : currentProject.jobs,
        addressStatus,
        geocode
    ]);
    var job = useMemo(function() {
        return currentProject.jobs.find(function(param) {
            var id = param.id;
            return id === job_id;
        });
    }, [
        currentProject.jobs,
        job_id
    ]);
    var activityMetadata = useMemo(function() {
        if (job && type === ACTIVITY_TYPES.order && metadata) {
            return metadata;
        }
        return null;
    }, [
        job,
        type,
        metadata
    ]);
    var jobActivity = props.jobActivity;
    var isSuperseded = superseded_assets.length > 0;
    var isDeleteActivityOptionVisible = isAdministrator(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) && !isNil(project_id);
    var isSupersedeButtonOptionVisible = created_assets && created_assets.length > 0;
    return !isActivityType(jobActivity, 'status') ? /*#__PURE__*/ React.createElement(Activity, {
        className: classnames('JobActivity', {
            isStaff: isStaff(visibility)
        })
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Activity.Icon, {
        iconProps: {
            icon: getActivityIcon()
        }
    }), /*#__PURE__*/ React.createElement(Activity.Card, {
        className: classnames({
            superseded: isSuperseded
        })
    }, /*#__PURE__*/ React.createElement(Activity.Card.Header, null, /*#__PURE__*/ React.createElement(Row, {
        className: "m-0 w-100"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "main-content font-weight--500 font-12"
    }, /*#__PURE__*/ React.createElement(Activity.Card.Type, {
        type: type ? capitalize(getActivityType(type)) : null
    }), /*#__PURE__*/ React.createElement(Activity.Card.Date, {
        hasPipeSeparator: job_id || project_id,
        date: formatDate(created_at),
        time: formatTime(created_at, 'h:mmaaa')
    }), project_id ? /*#__PURE__*/ React.createElement(Activity.Card.HeaderElement, {
        className: classnames({
            hasPipeSeparator: !!job_id
        }, 'projectId')
    }, text('projectId'), ":", project_id) : null, job_id ? /*#__PURE__*/ React.createElement(Activity.Card.HeaderElement, {
        className: "jobId"
    }, text('orderId'), ":", job_id) : null, is_notification_sent ? /*#__PURE__*/ React.createElement(OverlayTrigger, {
        delay: {
            show: 250
        },
        placement: "auto",
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            className: "notification-sent"
        }, text('notificationSent'))
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "envelope"
    })) : null), isStaff(visibility) && /*#__PURE__*/ React.createElement("span", {
        className: "larki-tag"
    }, "[".concat(text('larkiOnly'), "]"), " "), /*#__PURE__*/ React.createElement(Activity.Card.HeaderRight, {
        classNames: "d-flex flex-row align-items-center justify-content-end flex-fill"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, isSuperseded ? text('supersededStatus') : null), (!(created_user === null || created_user === void 0 ? void 0 : created_user.full_name) || isStaff(created_user === null || created_user === void 0 ? void 0 : created_user.role)) && !isStaff(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) ? 'LARKI' : created_user === null || created_user === void 0 ? void 0 : created_user.full_name, isDeleteActivityOptionVisible || isSupersedeButtonOptionVisible ? /*#__PURE__*/ React.createElement("div", {
        className: "ActivityDropdownMenuContainer position-relative"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: "more",
        onClick: function() {
            return setIsDropdownOpen(!isDropdownOpen);
        },
        ref: refs.setReference,
        className: "ActivityDropdownMenuTrigger ml-2"
    }), isDropdownOpen ? /*#__PURE__*/ React.createElement(FloatingPortal, null, /*#__PURE__*/ React.createElement("div", {
        ref: refs.setFloating,
        style: _object_spread({}, floatingStyles),
        className: "ActivityDropdownMenu dropdown-menu show"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: arrowRef,
        style: _object_spread_props(_object_spread({}, arrowStyles), {
            boxShadow: isFlipped ? '2px 2px 2.546px 0px rgba(0, 0, 0, 0.04)' : '-2px -2px 2.546px 0px rgba(0, 0, 0, 0.04)'
        }),
        className: "dropdown-arrow"
    }), created_assets && created_assets.length > 0 ? /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            onSupersede();
            setIsDropdownOpen(false);
        },
        className: "py-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: isSuperseded ? 'u_folder-add' : 'u_folder-minus',
        className: "original default-stroke mr-2"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "font-14 m-0"
    }, isSuperseded ? 'Reverse supersede to include ' : 'Supersede to exclude ', 'from "Download all"'))) : null, isAdministrator(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) && !isNil(project_id) ? /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: function() {
            onDeleteActivity();
            setIsDropdownOpen(false);
        },
        className: "py-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "trash",
        className: "mr-2 size-20 default-stroke danger",
        style: {
            marginLeft: '-2px'
        }
    }), /*#__PURE__*/ React.createElement("p", {
        className: "font-14 m-0 mt-1 font-danger"
    }, text('deleteActivity')))) : null)) : null) : null)), addressStatus === 'checking' ? /*#__PURE__*/ React.createElement("div", {
        className: "position-relative w-100"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        size: 8
    })) : shortenedAddress ? /*#__PURE__*/ React.createElement(Row, {
        className: "w-100 d-flex font-weight--400 font-12"
    }, shortenedAddress) : null), /*#__PURE__*/ React.createElement("div", {
        className: "ActivityContent"
    }, !isEmpty(metadata) ? /*#__PURE__*/ React.createElement(ActivityTemplate, {
        metadata: activityMetadata,
        job: job,
        rfqCharges: rfqCharges,
        description: description
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "ActivityTitle font-16 font-weight--600 text-uppercase"
    }, title), created_assets ? /*#__PURE__*/ React.createElement(ActivityAsset, {
        onDelete: onDeleteAsset,
        projectId: project_id,
        assets: created_assets,
        currentUser: currentUser,
        isSuperseded: isSuperseded
    }) : null, /*#__PURE__*/ React.createElement(ReactMarkdown, {
        linkTarget: "_blank",
        remarkPlugins: [
            remarkGfm
        ]
    }, description)))))) : /*#__PURE__*/ React.createElement(JobStatusUpdate, {
        detailedStatuses: detailed_status_update,
        createdDate: created_at,
        activityTitle: title,
        activityDescription: description,
        jobId: job_id,
        projectId: project_id
    });
};
JobActivity.propTypes = {
    jobActivity: T.shape(),
    currentUser: T.shape(),
    currentProject: T.shape()
};
export default JobActivity;
